import { CommonModule } from '@angular/common';
import { PutOnHoldInfoDialogComponent } from '@app/shared/put-on-hold-info-dialog/put-on-hold-info-dialog.component';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [PutOnHoldInfoDialogComponent],
  imports: [CommonModule, MatDialogModule, MatButtonModule, TranslateModule],
  exports: [PutOnHoldInfoDialogComponent],
})
export class PutOnHoldInfoDialogModule {}
